module.exports = __webpack_public_path__ + "static/media/person-picking-up-a-box-svgrepo-com.91f2c1fc.svg";